import React, { useEffect, useRef, useState } from "react";
import "./GenericChatbotContainer.css";
import iq_api_v2 from "../../../../services/iqApiV2";
import { useParams } from "react-router-dom";
import { useUser } from "../../../../context/UserContext";
import { useDispatch, useSelector } from "react-redux";
import { fetchOpportunitiesRequest } from "../../../../store/features/actions/opportunities/opportunitesActions";
import { fetchWinOpportunitiesRequest } from "../../../../store/features/actions/opportunities/winOpportunitiesActions";
import IOSSpinner from "../../../HtmlElements/IOSSpinner";
import SelectDropDownComp from "./selectDropDownComp";
import { FetchSpotContactsRequest } from "../../../../store/features/actions/targetedReachout/spotContactsActions";
const AddContactForm = ( {handleOnDealApply} ) => {
    const { opportunitesData, opportunitesLoading } = useSelector(state => state.opportunitiesReducer);
    const { winOpportunitesData, winOpportunitesLoading } = useSelector(state => state.winOpportunitiesReducer);
  
    const [selectedOpps, setSelectedOpps] = useState([]);
  
    const handleApplyClick = () => {
      handleOnDealApply(selectedOpps); // 🔥 This was missing!
      setSelectedOpps([])
      
    };
  
    return (
      <div>
        <div className="chatbot-add-container">
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <span className="chatbot-form-text-titl">Please select Opportunities</span>
            <span className="chatbot-form-text-titl" style={{ cursor: "pointer" }} onClick={() => setSelectedOpps([])}>clear</span>
          </div>
          <SelectDropDownComp
            allOptions={[...opportunitesData, ...winOpportunitesData]}
            selectedValues={selectedOpps}
            setSelectedValues={setSelectedOpps}
            onApply={handleApplyClick} // ✅ correctly passed handler
            multiSelect={true}
            valueKey="_id"
            labelKey="opportunity_name"
            disableFooter={false}
          />
        </div>
      </div>
    );
  };
  
const ChatbotForIds = ({ onBack, type,onApply }) => {
  const dispatch = useDispatch();

  
  const { clientName, accountName } = useParams();
  const { user } = useUser();

  const [history, setHistory] = useState("");
  const [isContactFind, setIsContactFind] = useState(false);
  const [isContactAdd, setIsContactAdd] = useState(false);
  const [oppData, setOppData] = useState({
    contact_name: "",
    opportunity_description: "",
  });
  const [message, setMessage] = useState("");
  const [chatMessages, setChatMessages] = useState([]);
  const [addCondata,setAddConData] = useState();

  
  
  const textareaRef = useRef(null);
  const containerRef = useRef(null);

  const getTime = () =>
    new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });


  useEffect(() => {
    if (type === "spot") {
      setChatMessages([
        {
          sender: "SalesIQ",
          message: `Hi ${user?.firstname}! 👋 Please select opportunities to create a deal`,
          timestamp: getTime(),
        },
        {
            sender: "SalesIQ",
            message:  <AddContactForm handleOnDealApply={handleOnDealApply}  onApply={onApply}/>,
            timestamp: getTime(),
        }
      ]);
    } 
  }, [type, user?.firstname]);

  const pushMessage = (sender, message, isLoading = false) => {
    setChatMessages((prev) => [
      ...prev,
      {
        sender,
        message,
        isLoading,
        timestamp: !isLoading ? getTime() : undefined,
      },
    ]);
  };

  const updateLastMessage = (message) => {
    setChatMessages((prev) => {
      const updated = [...prev];
      updated[updated.length - 1] = {
        ...updated[updated.length - 1],
        message,
        isLoading: false,
        timestamp: getTime(),
      };
      return updated;
    });
  };

  const handlePostSuccess = (response) => {
    const nextPrompt =
      response?.data?.next_prompt ||
      `Thnaks . You’ll see it inside ${type} Opportunities in 1–2 minutes.`;
    const historyTxt =
      response?.data?.task_id === 0 ? response?.data?.history : "";
    const shouldFetch = response?.data?.task_id === 1;

    setHistory(historyTxt);
    updateLastMessage(nextPrompt);

    if (shouldFetch) {
      const action =
        type === "spot"
          ? fetchOpportunitiesRequest
          : fetchWinOpportunitiesRequest;
      dispatch(action({ clientName, accountName, userId: user?.id, type }));
    }
  };



  const handleOnDealApply=(data)=>{
    onApply(data?.map((item)=>item?._id))
    pushMessage("SalesIQ",<>Generating your deal ! . This may take few seconds</>)
  }

  const handleAPIAddOpp = async (input) => {
    if (!input.trim()) return;

    pushMessage(user?.firstname || "User", input);
    setMessage("");

    if (input === "Find Contact") {
      setIsContactFind(true);
      setIsContactAdd(false);
      setOppData({})
      pushMessage("SalesIQ", <>Please Give a Contact Name</>);
      return;
    }

    if (input === "Add Contact") {
      setIsContactFind(false);
      setIsContactAdd(true);
      if (!oppData.contact_name) {
        pushMessage("SalesIQ",     
        <AddContactForm handleOnDealApply={handleOnDealApply}/>);
      }
    }


    // ✅ Update oppData in add flow
    if (isContactAdd) {



      const data = {
        client: clientName,
        account: accountName,
        contact_name: addCondata?.selectedOpps?.contact_name
         || input,
        opportunity_name: addCondata?.selectedOpp?.name,
        opportunity_description: addCondata?.selectedOpp?.description,
        funnel_stage:"first meeting",
        custom_instructions:input
      };

      pushMessage("SalesIQ", "", true); // Show loading

      try {
        const response = await iq_api_v2.post(
          "touch_nurture_sequence",
          {},
          { params: data }
        );
        handlePostSuccess(response);
        updateLastMessage(
          "Contact Will be created Shortly"
        );
      } catch (err) {
        updateLastMessage(
          `❗ ${err?.response?.data?.message || "Something went wrong"}`
        );
      }

      return;
    }

    // Handle Find Contact API
    if (isContactFind) {
      if (!oppData.contact_name) {
        setOppData((prev) => ({ ...prev, contact_name: input }));
        pushMessage(
          "SalesIQ",
          <>Please Give Opportunity Name</>
        );
        return;
      }
      if (!oppData.opportunity_name) {
        setOppData((prev) => ({ ...prev, opportunity_name: input }));
        pushMessage(
          "SalesIQ",
          <>Please Give Opportunity Description in 50 to 100 words</>
        );
        return;
      }
      if (!oppData.opportunity_description) {
        setOppData((prev) => ({ ...prev, opportunity_description: input }));
        pushMessage(
          "SalesIQ",
          <>Please Provide Some Instructions</>
        );
        return;
      }
      if (!oppData.custom_instructions) {
        setOppData((prev) => ({ ...prev, custom_instructions: input }));

        pushMessage(
          "SalesIQ",
         null,true
        );
      }

      try {
        const data = {
          client: clientName,
          account: accountName,
          contact_name: oppData.contact_name || input,
          opportunity_name: oppData.opportunity_name || input,
          opportunity_description: oppData.opportunity_description || input,
          funnel_stage:"first meeting",
          custom_instructions:oppData.custom_instructions||input
        };

        const response = await iq_api_v2.post(
          "touch_nurture_sequence",
          {},
          { params: data }
        );
        if (response) {
            setChatMessages((prev) => {
            const updated = [...prev];
            if (updated.length > 0 && updated[updated.length - 1].isLoading) {
              updated.pop();
            }
            return updated;
          });

          pushMessage(
            "SalesIQ",
            <>Finding and creating contact shortly</>,
          );
        }

      } catch (err) {
        updateLastMessage(
          `❗ ${err?.response?.data?.message || "Something went wrong"}`
        );
      }
    }
  };

  const renderMessages = (messages) =>
    messages.map((msg, index) => {
      const isUser = msg.sender === user?.firstname;
      const prevSender = index > 0 ? messages[index - 1].sender : null;
      const showSender = msg.sender !== prevSender;
      return (
        <div
          key={index}
          className={`message-wrapper ${isUser ? "align-right" : "align-left"}`}
        >
          {showSender && <p className="sender-name">{msg.sender}</p>}
          <div
            className={`message-bubble-${isUser ? "User" : msg.sender} ${
              msg.isLoading ? "is-loading" : ""
            }`}
          >
            <div className="message-content">{msg.message}</div>
            {!msg.isLoading && msg.timestamp && (
              <div
                className={`message-timestamp-${isUser ? "User" : msg.sender}`}
              >
                {msg.timestamp}
              </div>
            )}
          </div>
        </div>
      );
    });

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [message]);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [chatMessages]);

  return (
    <div className="chatbox-container">
      <div className="chatbox-header" onClick={onBack}>
        <img className="back-btn-img" src="/img/back_top.png" />
        <span className="back_chat_top">Back</span>
      </div>

      <div className="chatbox-messages-container" ref={containerRef}>
        {renderMessages(chatMessages)}
      </div>

      <div className="chatbox-input-container">
        <textarea
          ref={textareaRef}
          className="chatbox-input"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Describe your opportunity"
        />
        <button
          className="send-button"
          onClick={() => handleAPIAddOpp(message)}
        >
          <img className="send-button-img" src="/img/arrow-up.png" />
        </button>
      </div>
    </div>
  );
};

export default ChatbotForIds;
